export const inputTimeFormat = 'HH:mm:ss';
export const outputTimeFormat = 'h:mm A';

export const inputDateFormat = 'YYYY-MM-DD';
export const outputDateFormat = 'ddd, MMM D';

export const outputSameElseDateFormat = 'MMM D';

export const fullDateFormat = 'MM/DD/YY';

export const calendarDateFormat = {
  sameDay: '[Today]',
  nextDay: '[Tomorrow]',
  nextWeek: outputDateFormat,
  lastDay: '[Yesterday]',
  lastWeek: `[Last] ${outputDateFormat}`,
  sameElse: outputSameElseDateFormat
};
